<template>
  <section class="py-4 bg-white background_pattern overflow-y-auto">
    <div class="container px-4 mx-auto">
      <div class="max-w-sm mx-auto">
        <div class="mb-6 text-center">
          <a
            class="inline-block mb-6"
            href="#"
          >
            <img
              class="h-16"
              src="../assets/Images/djuliImageSquared.png"
              alt=""
            >
          </a>
          <h3 class="mb-4 text-2xl md:text-3xl font-bold">
            Sign in to your account
          </h3>
          <p class="text-lg text-coolGray-500 font-medium">
            Solution for your electrochemical sensor data
          </p>
        </div>
        <form @submit.prevent="submitForm">
          <div class="mb-6">
            <label
              class="block mb-2 text-coolGray-800 font-medium"
              for=""
            >Email</label>
            <input
              v-model="email"
              class="
                appearance-none
                block
                w-full
                p-3
                leading-5
                text-coolGray-900
                border border-coolGray-200
                rounded-lg
                shadow-md
                placeholder-coolGray-400
                focus:outline-none
                focus:ring-2
                focus:ring-green-500
                focus:ring-opacity-50
              "
              type="email"
              placeholder="example@djuli.no"
            >
          </div>
          <div class="mb-4">
            <label
              class="block mb-2 text-coolGray-800 font-medium"
              for=""
            >Password</label>
            <input
              v-model="password"
              class="
                appearance-none
                block
                w-full
                p-3
                leading-5
                text-coolGray-900
                border border-coolGray-200
                rounded-lg
                shadow-md
                placeholder-coolGray-400
                focus:outline-none
                focus:ring-2
                focus:ring-green-500
                focus:ring-opacity-50
              "
              type="password"
              placeholder="************"
            >
          </div>
          <div class="flex flex-wrap items-center justify-between mb-6">
            <div class="w-full md:w-1/2">
              <label class="relative inline-flex items-center">
                <input
                  v-model="trustComputer"
                  class="form-checkbox"
                  type="checkbox"
                >
                <span class="ml-1 text-xs text-coolGray-800 font-medium">Remember me</span>
              </label>
            </div>
            <div class="w-full md:w-auto mt-1">
              <router-link
                to="forgotPassw"
                class="
                  inline-block
                  text-xs
                  font-medium
                  text-green-500
                  hover:text-green-600
                "
              >
                Forgot your password?
              </router-link>
            </div>
          </div>
          <button
            type="submit"
            class="
              inline-block
              py-3
              px-7
              mb-6
              w-full
              text-base text-green-50
              font-medium
              text-center
              leading-6
              bg-green-500
              hover:bg-green-600
              focus:ring-2 focus:ring-green-500 focus:ring-opacity-50
              rounded-md
              shadow-sm
            "
          >
            Sign In
          </button>
          <p class="text-center space-x-2">
            <span class="text-xs font-medium">Don’t have an account?</span>
            <router-link
              to="register"
              class="
                inline-block
                text-xs
                font-medium
                text-green-500
                hover:text-green-600 hover:underline
              "
            >
              Sign up
            </router-link>
          </p>
        </form>
      </div>
    </div>
    <teleport to="body">
      <div v-if="loader">
        <spin-loading />
      </div>
    </teleport>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SpinLoading from '../newUI/SpinLoading.vue';
// import ErrorHandler from "./ErrorHandler.vue";

export default {
  name: 'Login',
  metaInfo: {
    title: 'Sign In – Djuli',
    meta: [
      { name: 'description', content: 'Sign in to your Djuli account to access your sensor data analysis projects.' },
      { property: 'og:title', content: 'Sign In – Djuli' },
      { property: 'og:url', content: 'https://dju.li/login' },
      { property: 'og:type', content: 'website' },
    ],
  },
  components: { SpinLoading },
  mounted() {
    document.dispatchEvent(new Event('render-event'));
  },
  data() {
    return {
      email: '',
      loader: false,
      password: '',
      formisValid: true,
      error: null,
      userNotFound: false,
      trustComputer: false,
    };
  },
  computed: mapGetters([
    'getBasicUserDataMiddlewareAuth',
    'getLastErrorMiddleware',
  ]),
  methods: {
    ...mapActions([
      'loginMiddlewareAuth',
      'resendVerifMiddlewareAuth',
      'readBasicUserDataMiddlewareAuth',
    ]),
    async submitForm() {
  this.loader = true;
  this.userNotFound = false;
  try {
    // Check if the user is verified
    const successVerif = await this.readBasicUserDataMiddlewareAuth({
      email: this.email,
    });
    if (!successVerif) {
      if (this.getLastErrorMiddleware.code === 'auth/user-not-found') {
        this.loader = false;
        this.userNotFound = true;
        this.email = '';
        this.password = '';
        this.trustComputer = false;
        await this.$alert(
          'Either provided email address or password is not correct. Please check your credentials',
          'Login error',
          'error'
        );
      } else {
        const errText =
          'Something went wrong. Please verify your connection and try again.';
        const errTitle = 'Connection failed';
        const errZone = 'Login';
        this.$notifTerm.addNotification(
          this.$notifTerm.typesNotif.ERROR,
          errTitle,
          errText,
          errZone
        );
      }
      this.loader = false;
      return;
    }

    const basicUserData = this.getBasicUserDataMiddlewareAuth;
    if (!basicUserData.emailVerified) {
      try {
        this.loader = false;
        await this.$confirm(
          'The account has not been activated. Should we send a new email?',
          'Not verified',
          'warning',
          {
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
          }
        );
        const successResend = await this.resendVerifMiddlewareAuth({
          email: this.email,
        });
        if (!successResend) {
          throw 'Error in server to resend the verification';
        }
        await this.$alert(
          'You should receive an email soon',
          'Email sent',
          'success',
          {
            confirmButtonText: 'Got it!',
          }
        );
        return;
      } catch (error) {
        await this.$alert(
          'Failed to resend the email. Please try again',
          'Email Verification',
          'error'
        );
        return;
      }
    }

    const loginsuccess = await this.loginMiddlewareAuth({
      email: this.email,
      password: this.password,
      trustPC: this.trustComputer,
    });
    if (loginsuccess === true) {

      // Decode the redirect URL only once
      let redirectUrl = this.$route.query.redirect;
      if (redirectUrl) {
        redirectUrl = decodeURIComponent(redirectUrl);
      }

      // Push to the decoded URL or fallback to '/navigation'
      this.$router.push(redirectUrl || '/navigation');
    }
    this.loader = false;
  } catch (error) {
    this.loader = false;
    await this.$alert(
      'Either provided email address or password is not correct. Please check your credentials',
      'Login error',
      'error'
    );
  } finally {
    this.loader = false;
  }
},
  },
};
</script>

<style lang="scss" scoped>
.djuliLogo {
  width: 30vw;
  position: fixed;
  left: 35vw;
  margin: auto;
  opacity: 0.5;
  z-index: -100;
}

.login-container {
  width: 18vw;
  height: 65vh;
}

.form-group {
  margin-top: 1rem !important;
}

.btn-margin {
  margin-left: 0.5rem;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
}

h3 {
  margin-top: 1rem !important;
}

.active {
  opacity: 0.3;
}

.loader {
  position: absolute;
  left: 46%;
  top: 40%;
}

.out-text {
  display: inline-flex;
  position: relative;
  font-size: 1rem;
  margin: 0;
  padding: 0;
  text-align: right;
}

.user-not-registered {
  color: red;
  font-size: medium;
  text-align: justify;
}

.background_pattern {
  background-image: url("../assets/SVG/pattern-white.svg?inline");
  background-position: center;
}
</style>
